import * as types from "./types";

const INITIAL_STATE = {
  formData: {},
};

const evaluations = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_EVALUATION_RESPONSE:
      return {
        ...state,
        formData: { ...action.payload },
      };
    case types.VIEW_FORM_RESPONSE:
      return {
        ...state,
        formData: { ...action.payload },
      };
    default:
      return state;
  }
};

export default evaluations;
